import { Auth } from 'aws-amplify';

class AuthService {
  async signIn(username, password){
    return await Auth.signIn(username, password)
      .then(user => {
        // console.log(user);
        return user;
      })
      .catch(err => console.log(err));
  }

  async signOut(){
    return await Auth.signOut()
      .then(data => {return data;})
      .catch(err => console.log(err));
  }

  async isLogin(){
    return await Auth.currentSession()
      .then((session) => {
        // console.log(session);
        return true;
      })
      .catch((err) => {
        console.log(err);
        return false;
      });
  }

  async changePassword(oldPassword, newPassword){
    return await Auth.currentAuthenticatedUser()
      .then(user => {
        return Auth.changePassword(user, oldPassword, newPassword)
          .then(succsess => {
            console.log(succsess)
            return true
          })
          .catch(err => {
            console.log(err)
            return err
          });
      })
      .catch(err => console.log(err));
  }

  async completeNewPassword(user, password, attribute){
    return await Auth.completeNewPassword(user, password, attribute)
      .then(user => {
        // console.log(user);
        return user;
      })
      .catch(err => {
        console.log(err);
        return err;
      });
  }

  async getNickname(){
    return await Auth.currentAuthenticatedUser()
      .then(user => {
        return Auth.userAttributes(user)
          .then(attributes => {
            let nickname = "unknown"
            attributes.forEach((item) => {
              if(item.Name === "nickname"){
                nickname = item.Value
              }
            })
            return nickname;
          })
          .catch(err => console.log(err));
      })
      .catch(err => console.log(err));

  }

  async getCurrentCredentials(){
    return await Auth.currentCredentials()
      .then(credentials => {
        return credentials;
      })
      .catch(err => {
        console.log(err);
        return err;
      });
  }
}

export default AuthService
